// ATHL8: cart discount code form
// Submitting redirects to Shopify's /discount/{code} URL, which sets a cart
// cookie and bounces the customer back to /cart with the discount applied.
(function () {
  function bind(form) {
    if (!form || form.dataset.bound === '1') return;
    form.dataset.bound = '1';

    var input = form.querySelector('.cart-discount__input');
    var btn = form.querySelector('.cart-discount__btn');

    form.addEventListener('submit', function (evt) {
      evt.preventDefault();
      if (!input) return;
      var code = (input.value || '').trim();
      if (!code) {
        input.focus();
        return;
      }
      if (btn) { btn.disabled = true; btn.textContent = 'BEZIG…'; }
      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
    });
  }

  function init(root) {
    (root || document).querySelectorAll('[data-cart-discount-form]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Re-bind when the cart drawer refreshes its DOM (cart-form merges nodes)
  document.addEventListener('on:cart:after-merge', function () { init(); });
})();
